module.exports = __webpack_public_path__ + "static/slideA-8f7d0a7b5121babd1a862228a1492b8a.png";